import React from 'react';
import { getValidVariant } from '../_utils';
var Badge = function (props) {
    var variant = props.variant, outline = props.outline, children = props.children, className = props.className;
    var getClassName = function () {
        return "badge badge-" + getValidVariant(variant) + " " + (outline ? 'badge-outline-' + getValidVariant(variant) : '') + (className ? " " + className : '');
    };
    return React.createElement("span", { className: getClassName() }, children);
};
export default Badge;
